import React from 'react';


interface InfoProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    rowToEdit: any;
    reloading: () => void;
}

const DeleteLimits: React.FC<InfoProps> = ({ open, setOpen, rowToEdit, reloading }) => {
    return (
        <></>
    );
};

export { DeleteLimits };